import { useState } from 'react';

export function useId<T extends number | string = number>(initialValue?: T) {
  const [id, setId] = useState(initialValue);

  const clear = () => setId(undefined);

  const reset = () => setId(initialValue);

  return [id, setId, { clear, reset }] as const;
}

export function useStringId(initialValue?: string) {
  return useId<string>(initialValue);
}
